import { post } from "@insite/client-framework/Services/ApiService";

export interface RequestExpertAssistApiModel {
    phoneNumber: string;
    pageType: string;
    pageUrl: string;
    productName: string;
    productErpNumber: string;
    SubmittedFrom: string;
}

export interface RequestExpertAssistModel {
    id?: string;
    phoneNumber: string;
    pageType: string;
    pageUrl: string;
    productName: string;
    productErpNumber: string;
    SubmittedFrom: string;
}

const baseUrl = "/api/v1/centroconnect/expertassist";

export function requestExpertAssist(model: RequestExpertAssistApiModel) {
    return post<RequestExpertAssistApiModel, RequestExpertAssistModel>(baseUrl, model as any);
}